import type { FontStyle } from '../../items/text/text-item-type';

interface MeasureTextServerParams {
  text: string;
  fontSize: number;
  fontFamily: string;
  lineHeight: number;
  letterSpacing: number;
  fontStyle: FontStyle;
}

/**
 * 서버 환경에서 DOM 없이 텍스트 크기를 추정하는 함수.
 * 에디터 진입 시 클라이언트에서 실제 DOM 측정으로 보정되며,
 * Lambda 렌더링에서도 Remotion 환경에서 정확한 측정이 이루어지므로
 * 여기서는 레이아웃 배치용 근사값만 제공한다.
 */
export const getTextDimensionsServer = ({
  text,
  fontSize,
  // fontFamily, fontStyle: 향후 한글(~1.0)/라틴(~0.6) 폭 비율 분기에 활용 예정
  lineHeight,
  letterSpacing,
}: MeasureTextServerParams): { width: number; height: number } => {
  const avgCharWidth = fontSize * 0.6;
  const lines = text.split('\n');
  const maxLineLength = Math.max(...lines.map((line) => line.length));

  const width = Math.max(
    0,
    Math.ceil(maxLineLength * (avgCharWidth + letterSpacing) - letterSpacing),
  );
  const height = Math.round(lineHeight * fontSize * lines.length);

  return { width, height };
};
